import { render, staticRenderFns } from "./demo_form.vue?vue&type=template&id=0474ec49&scoped=true&"
import script from "./demo_form.vue?vue&type=script&lang=js&"
export * from "./demo_form.vue?vue&type=script&lang=js&"
import style0 from "./demo_form.vue?vue&type=style&index=0&id=0474ec49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474ec49",
  null
  
)

export default component.exports